import { type NotificationDto } from '../../../models/NotificationDto';
import { lineClampStyle } from '../core/_utils';

interface EventNotificationToastProps {
  notification: NotificationDto;
}

const formatDate = (dateString?: string): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
};

export const EventNotificationToast = ({ notification }: EventNotificationToastProps) => (
  <div className="min-w-0">
    <div className="fw-semibold text-gray-900" style={lineClampStyle(2)}>
      {notification.title}
    </div>
    {notification.description ? (
      <p className="m-0 fs-7 text-gray-600" style={lineClampStyle(3)}>
        {notification.description}
      </p>
    ) : null}
    {notification.registration_date ? (
      <div className="fs-8 text-gray-600 mt-2">{formatDate(notification.registration_date)}</div>
    ) : null}
  </div>
);

export default EventNotificationToast;
